export default __webpack_public_path__ + "f8abc5f98645ed09dc40b6d3ad7aeb74.png";